import { createRequest, RequestConfig } from '../../../core/libs/api';
import { NewTicketPayment } from '../types';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/add_order',
};

export const addOrderRequest = (newPay: NewTicketPayment) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(newPay),
  });
